import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import { blockedMessage } from "./EntryActionModal"
import { entryReadMessage, staleEntryCodes, staleEntryRead } from "./useEntryOperation"

// A move is one click, but still uses a fresh, server-verified revision. A preview that says the lists are out of date offers
// `onReload` (Reload entries) instead of Retry move.
export default function EntryMoveAction({ action, eventId, competitionId, pending, operationStatus, onConfirm, onClose, onReload, onStateChange }) {
  const [attempt, setAttempt] = useState(0), [state, setState] = useState({ checking: true })
  useEffect(() => { onStateChange?.(state) }, [state, onStateChange])
  const confirm = useRef(onConfirm)
  confirm.current = onConfirm
  useEffect(() => {
    let current = true
    setState({ checking: true })
    get(`/admin/events/${eventId}/competitions/${competitionId}/entry-preview`, { params: action, timeout: 15000 })
      .then(response => {
        if (!current) return
        const preview = response?.data
        if (preview?.eventId !== eventId || preview.competitionId !== competitionId || preview.entryId !== action.entryId
          || preview.action !== "move" || preview.destination !== action.destination || !preview.revision || typeof preview.allowed !== "boolean") {
          throw new Error("ENTRY_PREVIEW_UNAVAILABLE")
        }
        // A move never takes a reason (T2): the API does not ask one and this one-click action has no field for it. A refusal
        // without its code could not be checked.
        if (!preview.allowed) {
          setState({ message: blockedMessage(preview.blocked || "ENTRY_MOVE_CHECK_UNAVAILABLE"), blocked: preview.blocked, stale: staleEntryCodes.includes(preview.blocked) })
          return
        }
        setState({})
        confirm.current({ ...action, revision: preview.revision, reason: "" }, preview)
      }).catch(error => { if (current) setState({ message: entryReadMessage(error, "ENTRY_MOVE_CHECK_UNAVAILABLE"), stale: staleEntryRead(error) }) })
    return () => { current = false }
  }, [action, eventId, competitionId, attempt])
  const hasDrawBlock = ["MAIN_DRAW_POSITION_ASSIGNED", "PARTICIPATION_ALREADY_RECORDED"].includes(state.blocked)
  return <div id={`entry-move-${action.entryId}`} className={`alert alert-${state.message || operationStatus ? "warning" : "info"}`} role={state.message || operationStatus ? "alert" : "status"}>
    {state.checking ? "Checking the entry before moving…" : state.message || operationStatus || "Moving entry — waiting for the confirmed result…"}
    {hasDrawBlock && <p>Review Main Draw before changing this entry. <Link to={`/events/${eventId}/competitions/${competitionId}/matches`}>Open Main Draw</Link></p>}
    {!state.checking && !pending && <div>
      {state.stale ? <Button color="link" onClick={onReload}>Reload entries</Button>
        : <Button color="link" onClick={() => setAttempt(value => value + 1)}>Retry move</Button>}
      <Button color="link" onClick={onClose}>Dismiss</Button>
    </div>}
  </div>
}
